<template>
  <Toast />
  <ConfirmDialog></ConfirmDialog>
  <div class="card shadow ml-2 mr-2 mb-2">
    <div class="shadow sm:rounded-md sm:overflow-hidden">
      <div class="grid grid-cols-6 gap-4">

        <div class="col-span-6 ml-4">
          <label for="nombre-name" class="block text-sm font-medium text-gray-700"> Empresa o Afiliado Voluntario</label>
          <InputSwitch inputId="nombre-name" v-model="data.save.esEmpresa" @change="cleanCtaCte" /> <span
            class="text-xs">{{ textEsEmpresa }}</span>
        </div>

        <div class="col-span-6">
          <AutoComplete v-if="data.save.esEmpresa" v-model="empresa" class="w-full" :suggestions="data.empresasFiltradas"
            @complete="buscarEmpresa($event)" @item-select="mostrarCtaCte($event)" :dropdown="true" optionLabel="nombre"
            forceSelection>
          </AutoComplete>

          <Tarjeta v-else @devolverAfiliado="mostrarCtaCte"></Tarjeta>
        </div>

        <div class="col-span-6">
          <div class="relative flex py-5 items-center">
            <div class="flex-grow border-t border-gray-400"></div>
            <span class="flex-shrink mx-4 p-tag">Cuenta Corriente</span>
            <div class="flex-grow border-t border-gray-400"></div>
          </div>
        </div>

        <div class="col-span-6 xl:col-start-2 xl:col-span-2">
          <label for="desde">Desde</label>
          <Calendar inputId="desde" v-model="data.desde" :showIcon="true" dateFormat="mm/yy" class="mt-1 w-full" />
        </div>

        <div class="col-span-6 xl:col-span-2">
          <label for="hasta">Hasta</label>
          <Calendar inputId="hasta" v-model="data.hasta" :showIcon="true" dateFormat="mm/yy" class="mt-1 w-full" />
        </div>

        <div v-if="data.showCtaCte" class="card col-span-6">
          <Toolbar class="mb-4">
            <template #start>
              <Button label="Nuevo comprobante" icon="pi pi-plus" class="p-button-sm p-button-success mr-2"
                @click="setModal('movimiento', true)" />

              <Button label="Grupo Familiar" icon="pi pi-check" @click="setModal('grupoFamiliar', true)"
                class="p-button-sm mr-2" />

              <Button v-if="data.save.esEmpresa" label="Revisar Afiliados" icon="pi pi-list" @click="revisarAfiliados(data.idEmpresa)"
                class="p-button-sm p-button-secondary" />


            </template>
            <template #end>
              <Button label="Exportar" icon="pi pi-upload" class="p-button-sm p-button-help" @click="exportCSV($event)" />
            </template>
          </Toolbar>
          <BlockUI :blocked="load">
            <DataTable ref="dt" :value="dataModel" v-model:selection="selectedDatas" dataKey="id" :filters="filters"
              class="p-datatable-sm" showGridlines :loading="load" responsiveLayout="stack" rowGroupMode="subheader"
              groupRowsBy="periodo" :paginator="true" :rows="10"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              :rowsPerPageOptions="[10, 25, 50]"
              currentPageReportTemplate="Registro del {first} al {last} de {totalRecords} totales">
              <template #header>
                <div class="sm:flex flex-wrap">
                  <div class="sm:flex-none h-16">
                    <h5 class="mb-2 md:m-0 p-as-md-center">Detalle de cuenta corriente</h5>
                  </div>
                  <div class="sm:flex-grow h-16">
                    <span class="ml-8 p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                    </span>
                  </div>
                  <div class="sm:flex-grow h-16">
                    <Button type="button" label="Actualizar datos" icon="pi pi-refresh" class="p-button-text p-button-sm"
                      @click="mostrarCtaCte(data.save.esEmpresa ? data.idEmpresa : data.idAfiliado);" />
                  </div>
                </div>
              </template>

              <!-- <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column> -->
              <!-- <Column field="periodo" header="Periodo" :sortable="true" style="min-width:8rem"></Column> -->
              <Column field="periodo" header="Periodo" :sortable="true" style="min-width:8rem"></Column>
              <Column field="numero" header="Comprobante" :sortable="true" style="min-width:8rem"></Column>
              <Column field="detalleFactura" header="Detalle" :sortable="true" style="min-width:12rem"></Column>
              <Column field="detalle" header="Observaciones" :sortable="true" style="min-width:12rem"></Column>
              <Column field="debe" header="Debe" :sortable="true" style="min-width:8rem">
                <template #body="slotProps">
                  {{ formatCurrency(slotProps.data.debe) }}
                </template>
              </Column>
              <Column field="haber" header="Haber" :sortable="true" style="min-width:8rem">
                <template #body="slotProps">
                  {{ formatCurrency(slotProps.data.haber) }}
                </template>
              </Column>
              <Column field="saldo" header="Saldo" :sortable="true" style="min-width:8rem">
                <template #body="slotProps">
                  <span v-if="slotProps.data.idComprobante !== 0">
                    {{ formatCurrency(slotProps.data.saldo) }}
                  </span>
                  <span v-else>
                    <Tag class="mr-2" severity="warning" :value="formatCurrency(slotProps.data.saldo)"></Tag>
                  </span>

                </template>
              </Column>

              <Column :exportable="false" style="min-width:8rem">
                <template #body="slotProps">
                  <Button icon="pi pi-angle-down" class="p-button-text" type="button" label="Opciones"
                    @click="toggleMenuGrid($event, slotProps.data)" aria-haspopup="true"
                    :aria-controls="'overlay_submenu_' + slotProps.data.idComprobante" />
                  <Menu v-if="slotProps.data.idComprobante === 0" :id="'overlay_submenu_' + slotProps.data.idComprobante"
                    :ref="el => functionRefs(el, slotProps.data.idComprobante)" :model="itemsMenuViejo" :popup="true" />
                  
                  <Menu v-else-if="slotProps.data.idComprobante !== 0 && slotProps.data.Estado === 'P'" :id="'overlay_submenu_' + slotProps.data.idComprobante"
                    :ref="el => functionRefs(el, slotProps.data.idComprobante)" :model="itemsMenuPagado" :popup="true" />                    

                  <Menu v-else :id="'overlay_submenu_' + slotProps.data.idComprobante"
                    :ref="el => functionRefs(el, slotProps.data.idComprobante)" :model="itemsMenu" :popup="true" />
                </template>
              </Column>

              <ColumnGroup type="footer">
                <Row>
                  <Column footer="Total:" :colspan="6" footerStyle="text-align:right" />
                  <Column :footer="saldoTotal" />
                </Row>
              </ColumnGroup>

              <template #groupheader="slotProps">
                <div>
                  Periodo:
                  <Tag class="ml-2" severity="info">{{ slotProps.data.periodo.substring(0, 4) }} -
                    {{ slotProps.data.periodo.substring(4) }}</Tag>
                </div>
              </template>
            </DataTable>
            <br />



          </BlockUI>

          <Dialog header="Cuenta Corriente" v-model:visible="data.modales.viejo"
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '50vw' }" :modal="true">
            <Viejo :idAfiliado="data.idAfiliado" />
            <template #footer>
              <Button label="Aceptar" icon="pi pi-check" @click="setModal('viejo', false);" class="p-button-sm"
                autofocus />
              <Button label="Nuevo Movimiento" icon="pi pi-check" @click="setModal('Movimiento', true);"
                class="p-button-sm" autofocus />
            </template>
          </Dialog>

        </div>

      </div>
    </div>

    <Dialog header="Nuevo movimiento" v-model:visible="data.modales.movimiento"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '50vw' }" :modal="true">
      <Movimiento :idAfiliado="data.idAfiliado" :idEmpresa="data.idEmpresa" @save="graboMovimiento" />
    </Dialog>

    <Dialog header="Grupo Familiar" v-model:visible="data.modales.grupoFamiliar"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '50vw' }" :modal="true">
      <GrupoFamiliar :idAfiliado="data.idAfiliado" />
    </Dialog>



    <Dialog v-bind:header="nombreArchivo" v-model:visible="data.modales.imprimir"
      :breakpoints="{ '1000px': '75vw', '700px': '90vw' }" :style="{ width: '50vw' }" :modal="true">

      <div class="flex flex-wrap shadow-xl">
        <div class="m-4">
          <Button label="Imprimir" icon="pi pi-print" class="p-button-outlined p-button-secondary"
            @click="openPDF('print')" />
        </div>
        <div class="m-4">
          <Button label="Descargar" icon="pi pi-download" class="p-button-outlined p-button-secondary"
            @click="openPDF('download')" />
        </div>
        <div class="m-4">
          <Button icon="pi pi-search-minus" class="p-button-rounded p-button-secondary p-button-outlined"
            @click="data.modales.zoom -= 100" :disabled="data.modales.zoom < 500" />
        </div>
        <div class="m-4">
          <Button icon="pi pi-search-plus" class="p-button-rounded p-button-secondary p-button-outlined"
            @click="data.modales.zoom += 100" :disabled="data.modales.zoom > 3000" />
        </div>
      </div>
      <div class="flex mt-4 justify-center">

        <vue-pdf-embed :source="pdfSource" :height="data.modales.zoom" />

      </div>
    </Dialog>

    <!-- 
        <Sidebar v-model:visible="data.modales.imprimir" :baseZIndex="10000" position="full">
        <div class="flex flex-wrap shadow-xl">
        <div class="m-4">
          <Button label="Imprimir" icon="pi pi-print" class="p-button-outlined p-button-secondary" @click="openPDF('print')" />
        </div>
        <div class="m-4">
          <Button label="Descargar" icon="pi pi-download" class="p-button-outlined p-button-secondary" @click="openPDF('download')" />
        </div>
        <div class="m-4">
          <Button icon="pi pi-search-minus" class="p-button-rounded p-button-secondary p-button-outlined" @click="data.modales.zoom -= 100" :disabled="data.modales.zoom < 500"  />
        </div>
        <div class="m-4">
          <Button icon="pi pi-search-plus" class="p-button-rounded p-button-secondary p-button-outlined" @click="data.modales.zoom += 100" :disabled="data.modales.zoom > 3000" />
        </div>
      </div>
      <div class="flex mt-4 justify-center">
        <div>
          <vue-pdf-embed :source="pdfSource" :height="data.modales.zoom" />
        </div>
      </div> 
    </Sidebar>-->


  </div>
</template>

<script>
import { reactive, ref, onMounted, computed } from 'vue';
import WService from '@/plugins/ws';
import Menu from 'primevue/menu';
import AutoComplete from 'primevue/autocomplete';
import InputSwitch from 'primevue/inputswitch';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Toast from 'primevue/toast';
import { useToast } from "primevue/usetoast";
import ConfirmDialog from 'primevue/confirmdialog';
import { useConfirm } from "primevue/useconfirm";
import InlineMessage from 'primevue/inlinemessage';
import DataTable from 'primevue/datatable';
import Toolbar from 'primevue/toolbar';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import Tarjeta from '@/components/iosep/tarjetaTitular.vue';
import Calendar from 'primevue/calendar';
import Dialog from 'primevue/dialog';
import Sidebar from 'primevue/sidebar';
import { FilterMatchMode } from 'primevue/api';
import Tag from 'primevue/tag';
import BlockUI from 'primevue/blockui';
import Viejo from './ctacte_viejo.vue';
import Movimiento from './comprobante.vue';
import GrupoFamiliar from './Afiliados/GrupoFamaliar.vue'
import VuePdfEmbed from "vue-pdf-embed";
import printJS from 'print-js';
import { useRouter } from 'vue-router';
import { format, subYears } from 'date-fns'

export default {
  props: {
    info: Object,
  },
  emits: ['closeModal'],
  components: {
    Menu, InputSwitch, Toolbar, Button, InputText, AutoComplete,
    Toast, InlineMessage, DataTable, Column, ColumnGroup, Row, Tarjeta,
    Calendar, Dialog, Viejo, Movimiento, ConfirmDialog, Tag, BlockUI, VuePdfEmbed,
    Sidebar, GrupoFamiliar
  },
  setup(props, { emit }) {
    onMounted(() => {
      intialLoad();
    })
    const toast = useToast();
    const confirm = useConfirm();
    const wService = ref(new WService());
    const dt = ref(); //referencia a la tabla.
    const dataModel = ref(); //Datos de la tabla
    const selectedDatas = ref(); //Datos que seleccione
    const dataOnly = ref({}); //Cuando selecciono un dato
    const menu = ref([]); //referencia la menu de la grilla
    const filters = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const router = useRouter();
    const nombreArchivo = ref("");
    const load = ref(false);
    const empresa = ref();
    const pdfSource = ref("https://app.iosep.gob.ar/CRWeb/bin/Reports/output/ctacte_d369aaac-b5dc-4476-a1b1-aa24ea1b5be2.pdf");
    const data = reactive({
      desde: null,
      hasta: null,
      save: {
        esEmpresa: false,
      },
      modales: {
        viejo: false,
        movimiento: false,
        grupoFamiliar: false,
        imprimir: false,
        urlImprimir: '',
        zoom: 900
      },
      idAfiliado: 0,
      idEmpresa: 0,
      empresasFiltradas: [],
      errors: {},
      newReg: false,
      showCtaCte: false,
    });

    //menu de la tabla, solo para comprobantes nuevos.
    const itemsMenu = ref([
      {
        label: 'Opciones',
        items: [
          {
            label: 'Imprimir',
            icon: 'pi pi-print',
            command: () => {
              let idCom = dataOnly.value.idComprobante;
              imprimirComprobante(idCom);
            }
          },
          {

            label: 'Anular',
            icon: 'pi pi-ban',
            command: () => {
              alertAnular();
            }
          },
        ]
      },
    ]);
    
    //Menu de la tabla solo para comprobantes pagados
    const itemsMenuPagado = ref([
      {
        label: 'Opciones',
        items: [
          {
            label: 'Imprimir',
            icon: 'pi pi-print',
            command: () => {
              let idCom = dataOnly.value.idComprobante;
              imprimirComprobante(idCom);
            }
          },
        ]
      },
    ]);

    //Menu de la tabla, solo para comprobantes viejos.
    const itemsMenuViejo = ref([
      {
        label: 'Cuenta Corriente',
        items: [
          {
            label: 'Ver Cuenta Antigua',
            icon: 'pi pi-database',
            command: () => {
              data.modales.viejo = true;
            }
          }
        ]
      },
    ]);

    //Iniciar la carga de datos.
    const intialLoad = () => {
      // load.value = true;

      data.hasta = new Date();
      data.desde = subYears(data.hasta, 1);
      // wService.value.getMethod('Users/Extras/Fecha/' + "yyyy-MM-dd/" + "iosepSalud").then(info => {
      //   // console.log(info)

      //   data.desde = new Date(info.desde + "T00:00");
      //   data.hasta = new Date(info.hasta + "T00:00");
      //   load.value = false;
      // }).catch(err => {
      //   console.log(err.message);
      //   load.value = false;
      // });
    }

    //para asignar el id a cada registro para que funcione el menu.
    const functionRefs = (el, id) => {
      if (id === 0)
        id = "Viejo";
      menu.value[id] = el;
    }

    //muestra si es afi o empresa.
    const textEsEmpresa = computed(() => {
      let queEs = data.save.esEmpresa;
      return queEs ? "es Empresa" : "es Afiliado";
    })

    //Exporta a csv
    const exportCSV = () => {
      if (dt.value)
        dt.value.exportCSV();
    };

    //da formato a moneda
    const formatCurrency = value => {
      if (value)
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      return;
    };

    //calcula total del saldo
    const saldoTotal = computed(() => {
      let total = 0;
      if (dataModel.value.length > 0) {
        for (let item of dataModel.value) {
          total = item.saldo;
        }
      }
      return formatCurrency(total);
    });

    //formato de fecha
    const formatDate = value => {
      let [dateValues, timeValues] = ["0000000", "0000000"];
      if (value == undefined || value == null) {
        //nada
      } else {
        [dateValues, timeValues] = value.split('T');
        //const [month, day, year] = dateValues.split('/');
        //const [hours, minutes, seconds] = timeValues.split(':');
      }
      return dateValues;
    }

    //Abre el menu en la tabla
    const toggleMenuGrid = (event, data) => {
      let newID = data.idComprobante == 0 ? "Viejo" : data.idComprobante;
      menu.value[newID].toggle(event);
      dataOnly.value = data;
    };

    //abre el modal para editar.
    const setModal = (modal, open) => {
      data.modales[modal] = open;
    }

    //Se usa despues de generar el comprobante.
    const graboMovimiento = (info) => {
      //Muestro informacion grabada.
      dataModel.value = info;
      setModal('movimiento', false);
    }

    //para traer el pdf.
    const imprimirComprobante = (idComp) => {
      //console.log("llego");
      load.value = true;

      //console.log("idcom: "+idComp);
      wService.value.pdfMethod("Comprobantes/Imprimir/" + idComp).then(info => {
        //let urlPdf = "https://app.iosep.gob.ar/CRWeb/bin/Reports/output/" + info;
        nombreArchivo.value = 'Archivo CtaCte';
        var newBlob = new Blob([info.data], { type: "application/pdf" })
        const url = window.URL.createObjectURL(newBlob);
        data.urlImprimir = url;
        pdfSource.value = url;
        //console.log(info);

        load.value = false;
        //console.log(info);
        setModal("imprimir", true)
      }).catch(err => {
        load.value = false;
        console.log(err.message);
      });
    }

    //para imprimir o descargar pdf.
    const openPDF = (type) => {
      switch (type) {
        case "print":
          printJS(data.urlImprimir)
          break;
        case "download":
          window.open(data.urlImprimir);
          break;
      }
    }

    //busca las empresas
    const buscarEmpresa = (event) => {
      if (!load.value) {
        load.value = true;
        setTimeout(() => {
          if (event.query.length > 2 || event.query.length === 0) {
            wService.value.getMethod('empresas/' + event.query).then(info => {
              data.empresasFiltradas = info;
              load.value = false;
            }).catch(err => {
              console.log(err.message);
              load.value = false;
            });
          }
          else
            load.value = false;
        }, 250);
      }
    }

    //Muestra los datos de la cuenta corriente.
    //carga datos a la tabla.
    const mostrarCtaCte = (id) => {
      if (id === 0) {
        return;
      }
      load.value = true;

      let idBuscar;
      let param = "Afiliado";
      const desdeFormat = format(data.desde, 'yyyyMM');
      const hastaFormat = format(data.hasta, 'yyyyMM');
      if (id.value !== undefined) {
        data.idEmpresa = idBuscar = id.value.idEmpresa;
        param = "Empresa";
        data.idAfiliado = 0;
      }
      else {
        data.idAfiliado = idBuscar = id;
        data.idEmpresa = 0;
      }
      //Busco los datos de la ctacte...
      wService.value.getMethod(`Comprobantes/${param}/${idBuscar}?desde=${desdeFormat}&hasta=${hastaFormat}`).then(info => {
        //console.log(info);
        dataModel.value = info;
        data.showCtaCte = true;
        load.value = false;
      }).catch(err => {
        console.log(err.message);
        data.showCtaCte = false;
        load.value = false;
      });
    }

    //mensaje de confirmacion anula comprobante
    const confirmAnular = () => {
      if (data.save.esEmpresa) {
          confirm.require({
          message: `Desea anular el comprobante ${dataOnly.value.numero}?`,
          header: 'Anular',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            load.value = true;

            const deleteRequestPayload = {
                IdComprobante: dataOnly.value.idComprobante,
                IdAfiliado: dataOnly.value.idAfiliado,
                Periodo: dataOnly.value.periodo
            };
            wService.value.postMethod('Comprobantes/anularComprobante/', deleteRequestPayload)
              .then(info => {
                  dataModel.value = info;
                  load.value = false;
              })
              .catch(err => {
                  console.error('Error en la solicitud:', err.message);
                  load.value = false;
            });
          },
        });
      } 
      else {
        confirm.require({
          message: `Desea anular el comprobante ${dataOnly.value.numero}?`,
          header: 'Anular',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            load.value = true;
            wService.value.deleteMethod('Comprobantes/', dataOnly.value.idComprobante).then(info => {
              dataModel.value = info;
              load.value = false;
            }).catch(err => {
              console.log(err.message);
              load.value = false;
            });
          },
        });
      }
    }

    //anula comprobante
    const alertAnular = () => {
      //array de todos los numeroPago
      let arrayNumPago = dataModel.value.map(el => el.numeroPago).filter(el => el != null)

      //Numeros de la factura seleccionada
      let numPagoOnly = dataOnly.value.numeroPago
      let numFactOnly = dataOnly.value.numero
      let numPagoEachFact = dataModel.value.find(el => el.numeroPago === numFactOnly)

      if (numPagoOnly != null) {
        confirmAnular()
      }
      else {
        if (arrayNumPago.some((el) => el === numFactOnly)) {
          toast.add({
            severity:'warn', 
            summary: 'Anular',
            detail:`Para poder anular este comprobante primero debe anular el comprobante ${numPagoEachFact.numero}`, 
            life: 10000});
        }
        else confirmAnular()
      }
    }

    const cleanCtaCte = (event) => {
      dataModel.value = null;
      data.showCtaCte = false;
    }

    //enviar a vista para revisar afiliados
    const revisarAfiliados = async (idEmpresa) => {
      // try {
      //       const response = await wService.value.getMethod(`Empresas/validarUsuario`);
      //       if (response === "ok") {
      //         router.push({ name: 'Revisar Afiliados', params: { idEmpresa } });
      //       } else {
      //         alert('No autorizado para realizar esta acción.');
      //       }
      //     } catch (error) {
      //       console.error('Error al validar el usuario:', error);
      //       alert('Hubo un error al intentar validar el usuario.');
      //     }
      router.push({ name: 'Revisar Afiliados', params: { idEmpresa } });
    };

    return {
      data, filters, itemsMenu, itemsMenuViejo, load, selectedDatas, dataModel,
      empresa, pdfSource, nombreArchivo, router,

      textEsEmpresa, saldoTotal, itemsMenuPagado, exportCSV, formatCurrency, formatDate, setModal, graboMovimiento,
      intialLoad, mostrarCtaCte, toggleMenuGrid, functionRefs, buscarEmpresa, confirmAnular,
      openPDF, cleanCtaCte, revisarAfiliados
    };
  },
}
</script>